<template>
  <div class="realtime-trajectory-search">
    <div class="search-toolbar">
      <div class="toolbar-title">实时定位跟踪</div>
      <div class="filter-section">
        <el-select v-model="value.employeeId" placeholder="全部人员" size="small" class="filter-select-wide">
          <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select v-model="value.employeeStatus" placeholder="全部状态" size="small" class="filter-select-status">
          <el-option label="全部状态" value=""></el-option>
          <el-option label="任务中" value="1"></el-option>
          <el-option label="空闲" value="0"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="handleQuery">查询</el-button>
        <el-button type="default" size="small" icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      userList: [],
    }
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    autoRefresh: {
      type: Boolean,
      default: true
    },
    refreshSeconds: {
      type: Number,
      default: 30
    }
  },
  methods: {
    handleQuery () {
      this.$emit('handleQuery')
    },
    handleReset () {
      this.$set(this.value, 'employeeId', '')
      this.$set(this.value, 'employeeStatus', '')
      this.$emit('handleQuery')
    },
  }
}
</script>


<style lang="scss" scoped>
$nx-color-card: #fff;
$nx-color-text-1: #1f2937;
$nx-color-border-2: #ebeef5;
$nx-radius-lg: 4px;
$nx-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.05);
$nx-space-2: 8px;
$nx-space-3: 12px;

@mixin nx-surface-card {
  background: $nx-color-card;
  border: 1px solid $nx-color-border-2;
  border-radius: $nx-radius-lg;
  box-shadow: $nx-shadow-sm;
  box-sizing: border-box;
}

.realtime-trajectory-search {
  @include nx-surface-card;
  margin-bottom: 12px;
  flex-shrink: 0;
  overflow: hidden;
}

/* 标题与筛选同一行，避免「上标题、下空白」过高（对齐常见工具条高度） */
.search-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: $nx-space-2 $nx-space-3;
  padding: 10px 12px;
  box-sizing: border-box;
}

.toolbar-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 32px;
  color: $nx-color-text-1;
  flex-shrink: 0;
}

.filter-section {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: $nx-space-2 $nx-space-3;
  min-width: 0;
}

.filter-select-wide {
  width: 200px;
}

.filter-select-status {
  width: 120px;
}

@media (max-width: 992px) {
  .search-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-section {
    width: 100%;
  }

  .filter-select-wide,
  .filter-select-status {
    width: 100%;
  }
}
</style>
